export const MaxLocalLikes = 5;

export default interface LikeUnlikeTracker {
    likeButtonClickCount: number;
    likeUnlikeInProgress: boolean;
}
